import React from 'react';

function RadioInput({ name, value, id, checked, onChange, labelText, labelClassName = "circular-radio-option" }) {
    return (
        <label htmlFor={id} className={labelClassName}>
            <input
                type="radio"
                name={name}
                value={value}
                id={id}
                checked={checked}
                onChange={onChange}
            />
            <span className="custom-radio-circle"></span>
            <span className="option-text">{labelText}</span>
        </label>
    );
}

export default RadioInput;